<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat workshops",
    "pageDesc":"Baianat workshops provide an intense learning experience in certain topics for both students and professionals in design, code, business and technology. ",
    "mantra":"In depth technical |discussions.",
    "mantraDesc":"Baianat workshops were created to give an in depth practical experience for both students and professional in certain topics.",
    "sec1":"Intense conversations in different fields.",
    "sec1Items":{
      "1":{
        "title":"Design workshops",
        "desc":"Learn more about the latest design trends, brand creation process, animation and UI/UX design. "
      },
      "2":{
        "title":"Business workshops",
        "desc":"Discover the possibilities of business and how to integrate it communicates different marketing channels."
      },
      "3":{
        "title":"Development workshops",
        "desc":"From mobile apps to web apps, we go with you through a real case development project and discuss the technologies utilized."
      },
      "4":{
        "title":"Technology workshops",
        "desc":"Exploring the possible usage of technology and its integration with business and development solutions."
      }
    },
    "sec2":"Share your thoughts and practice instantly.",
    "sec2Items":{
      "1":{
        "title":"Practical cases",
        "desc":"We don’t just provide you with case studies, we work with you on real life examples from Baianat projects in which we implemented the concepts discussed."
      },
      "2":{
        "title":"Live discussions",
        "desc":"Have the space to ask all the burning questions you have in mind and let us walk you through solving it."
      }
    },
    "cta":"Register for our  <br> workshops today!"
  },
  "ar": {
    "pageTitle":"ورش عمل بيانات",
    "pageDesc":"توفر بيانات ورش عمل تعليمية مكثفة في مواضيع محددة لكل من الطلاب والمهنيين في التصميم والبرمجة والبيزنس والتكنولوجيا.",
    "mantra":"انخرط في المزيد من |المناقشات التقنية.",
    "mantraDesc":"تم إنشاء ورش عمل بيانات لإعطاء تجربة عملية مكثفة لكل من الطلاب والمهنيين في المواضيع التي تتناسب معهم ويبحثون في المزيد من المعرفة حولها.",
    "sec1":"محادثات مكثفة في مختلف المجالات.",
    "sec1Items":{
      "1":{
        "title":"ورش التصميم",
        "desc":"تعرف على المزيد حول أحدث اتجاهات التصميم وعملية إنشاء العلامة التجارية والرسوم المتحركة وتصميم واجهة المستخدم وتجربة المستخدم."
      },
      "2":{
        "title":"ورش البيزنس",
        "desc":"اكتشف الإمكانات الكاملة للعمليات التجارية وكيف ربط جهودك التسويقية ونشر رسالتك عبر جميع القنوات."
      },
      "3":{
        "title":"ورش البرمجة",
        "desc":"من تطبيقات الجوال إلى تطبيقات الويب، نتعاون معك من خلال مشروع برمجة حقيقي ومناقشة التقنيات المستخدمة فيه."
      },
      "4":{
        "title":"ورش التكنولوجيا",
        "desc":"اكتشف مزايا التكنولوجيا ومدى تكاملها مع بعضها البعض وكيف تؤثر بشدة على جميع الأعمال التجارية وغيرها."
      }
    },
    "sec2":"تبادل الأفكار ومارس كل ما تتعلمه على الفور.",
    "sec2Items":{
      "1":{
        "title":"حالات حقيقية",
        "desc":"لا نزودك فقط بدراسات الحالة، بل نعمل معك على أمثلة واقعية من مشاريع بيانات التي قمنا بتنفيذها وأهم  المفاهيم التي تمت مناقشتها خلال هذه المشاريع."
      },
      "2":{
        "title":"مناقشات حية",
        "desc":"لديك الحرية الكاملة في طرح جميع الأسئلة التي تدور في ذهنك ومناقشتها مهنا وكذلك الحصول على إجابتها الفورية منا."
      }
    },
    "cta":"سجل لورش العمل <br> لدينا الآن!"
  }
}
</i18n>
